(function ($) {
    $(function () {
        // get all inputs that are next to a floater. cf7 wraps those, so we need to go down one level
        var $input = $('.label').closest('label').find('input:not([type="date"]):not([type="file"]), textarea, select');
        // first set all labels down
        $input.each(function () {
            if ($(this).val() === '') {
                $(this).closest('label').addClass('empty');
            }
        });
        // then enable animations
        requestAnimationFrame(function () {
            $('.wpcf7-form').addClass('animated-labels');
        });
        // on focus lift label up
        $input.on('focus', function () {
            $(this).closest('label').removeClass('empty');
        });
        // on blur set the label down if field is empty
        $input.on('blur', function () {
            if ($(this).val() === '') {
                $(this).closest('label').addClass('empty');
            }
        });
        // something changed the contents
        $input.on('change', function () {
            if ($(this).val() === '') {
                $(this).closest('label').addClass('empty');
            }
            else {
                $(this).closest('label').removeClass('empty');
            }
        });
        $('.wpcf7').each(function () {
            $(this).on('wpcf7invalid', function () {
                setTimeout(function () {
                    $('.wpcf7-not-valid-tip').closest('.wpcf7-form-control-wrap').addClass('not-valid');
                }, 100);
            });
        });
        // manually reset the labels when wpcf7 clears the fields
        document.addEventListener('wpcf7mailsent', function () {
            setTimeout(function () {
                $input.trigger('change');
            }, 500);
        });
    });
})(jQuery);
